<div class="box-plugin box-tools">
    <!-- HEADER EXTRACT -->
    <div class="tools" #tools>
        <div class="links">
            <ul>
                <li>
                    <a class="trigger" (click)="openExtraction = !openExtraction" [ngClass]="{'disabled-link' : loading, 'active-button': openExtraction}">
                        <em>Extraction</em>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <!-- END HEADER EXTRACT -->


    <!-- LOADING -->
    <div *ngIf="loading">
        <core-helpers-box-loading></core-helpers-box-loading>
        <div class="relax-div outside"><p>We are extracting your content. <strong>Hold on</strong></p></div>
    </div>
    <!-- END LOADING -->


    <!-- EXTRACT  -->
    <div *ngIf="openExtraction" class="extraction-content" [ngClass]="{'info-open': infoOpened}">
        <div *ngIf="infoOpened" class="modal">
            <plugin-apollo-helpers-modal-ocr-info (action)="setInfo(!infoOpened)"></plugin-apollo-helpers-modal-ocr-info>
        </div>
        <div class="two-boxes-plugin" *ngIf="!loading">
            <plugin-apollo-helpers-content-extract-result [title]="'Your Reference'" [hash]="request.hash" [type]="'reference'" (infoClick)="setInfo($event)" (extract)="newExtract($event, 'reference')"></plugin-apollo-helpers-content-extract-result>
            <plugin-apollo-helpers-content-extract-result [title]="'Your Target'" [hash]="request.hash" [type]="'target'" (infoClick)="setInfo($event)" (extract)="newExtract($event, 'target')"></plugin-apollo-helpers-content-extract-result>
        </div>
    </div>
    <!-- END EXTRACT -->
</div>


<!-- ERROR -->
<!--<core-helpers-box-alert-try-again *ngIf="errorExtract" [text]="textError.text" (tryAgain)="tryAgain()" [textButton]="textError.button"></core-helpers-box-alert-try-again>
-->
<!-- END ERROR -->
